module.exports = __webpack_public_path__ + "logo-quickbutik.10a885c4a90f4ddd162a0ae64a1ce2df.svg";